var map = {
	"./americanas.png": 3048,
	"./bg-experiences.jpg": 1171,
	"./claro.png": 9667,
	"./deloitte.png": 1598,
	"./fale-conosco.png": 267,
	"./home-graph.jpg": 7304,
	"./ipiranga.png": 3709,
	"./itau.png": 6011,
	"./kabum.png": 8684,
	"./localiza.png": 6651,
	"./polishop.png": 2620,
	"./renner.png": 744,
	"./shoptime.png": 7177,
	"./submarino.png": 7434,
	"./testimonial.png": 17,
	"./ultrafarma.png": 3413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3064;